module.exports = __webpack_public_path__ + "img/mavic_2_480_60.fa765cdc.jpg";